import React from 'react';
import { AdminTabType } from '../types';

interface AdminTabNavigationProps {
  activeTab: string;
  onTabChange: (tabValue: AdminTabType['value']) => void;
}

const tabs: AdminTabType[] = [
  { id: 'dashboard', label: 'Panel', value: 'dashboard' },
  { id: 'equipment', label: 'Equipamiento', value: 'equipment' },
  { id: 'bookings', label: 'Reservas', value: 'bookings' },
  { id: 'categories', label: 'Categorías', value: 'categories' },
  { id: 'users', label: 'Usuarios', value: 'users' },
];

export const AdminTabNavigation: React.FC<AdminTabNavigationProps> = ({
  activeTab,
  onTabChange
}) => {
  return (
    <div
      className="flex px-4 mb-4 -mx-4 overflow-x-auto border-b border-gray-200 sm:mx-0 sm:px-0"
      role="tablist"
      aria-label="Admin tabs"
    >
      <div className="flex gap-2">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.value;
          return (
            <button
              key={tab.id}
              role="tab"
              aria-selected={isActive}
              tabIndex={0}
              onClick={() => onTabChange(tab.value)}
              className={`flex-shrink-0 whitespace-nowrap py-3 px-4 text-center border-b-2 font-medium text-base sm:text-sm cursor-pointer transition-colors focus:outline-none focus:ring-2 focus:ring-blue-200 ${
                isActive
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
